import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/directPage',
      component: (resolve) => require(['../views/class/directPage'], resolve),
    },
    {
      path: '/directErrorPage',
      component: (resolve) => require(['../views/class/directErrorPage'], resolve),
    },
    {
      path: '/',
      component: (resolve) => require(['../views/main/mainPage'], resolve),
      children: [
        {
          path: '/',
          component: (resolve) => require(['../views/class/mainContainer'], resolve),
        },
        {
          path: '/downloadPage',
          component: (resolve) => require(['../views/class/downloadPage'], resolve),
        },
        {
          path: '/identifyPage',
          component: (resolve) => require(['../views/class/identifyPage'], resolve),
        },
        {
          path: '/identifyOrgPage',
          component: (resolve) => require(['../views/class/identifyOrgPage'], resolve),
        },
        {
          path: '/publicityPage',
          component: (resolve) => require(['../views/class/publicityPage'], resolve)
        },
        {
          path: '/ndkhListPage',
          component: (resolve) => require(['../views/class/ndkhListPage'], resolve)
        },
        {
          path: '/publicityPageDetail',
          component: (resolve) => require(['../views/class/publicityPageDetail'], resolve)
        },
        {
          path: '/resultPage',
          component: (resolve) => require(['../views/class/resultPage'], resolve)
        },
        {
          path: '/ajpcPage',
          component: (resolve) => require(['../views/class/ajpcPage'], resolve)
        },
        {
          path: '/resultPageDetail',
          component: (resolve) => require(['../views/class/resultPageDetail'], resolve)
        },
        {
          path: '/ajpcPageDetail',
          component: (resolve) => require(['../views/class/ajpcPageDetail'], resolve)
        },
        {
          path: '/affichePage',
          component: (resolve) => require(['../views/class/affichePage'], resolve)
        },
        {
          path: '/afficheDetailPage',
          component: (resolve) => require(['../views/class/afficheDetailPage'], resolve)
        },
        {
          path: '/industryPage',
          component: (resolve) => require(['../views/class/industryPage'], resolve)
        },
        {
          path: '/industryPageDetail',
          component: (resolve) => require(['../views/class/industryPageDetail'], resolve)
        },
        {
          path: '/noticePage',
          component: (resolve) => require(['../views/class/noticePage'], resolve)
        },
        {
          path: '/policyPage',
          component: (resolve) => require(['../views/class/policyPage'], resolve)
        },
        {
          path: '/adminPage',
          component: (resolve) => require(['../views/class/adminPage'], resolve)
        },
        {
          path: '/adminPageDetail',
          component: (resolve) => require(['../views/class/adminPageDetail'], resolve)
        },
        {
          path: '/workStatusPage',
          component: (resolve) => require(['../views/class/workStatusPage'], resolve)
        },
        {
          path: '/workStatusPageDetail',
          component: (resolve) => require(['../views/class/workStatusPageDetail'], resolve)
        },
        {
          path: '/identifyPageDetail',
          component: (resolve) => require(['../views/class/identifyPageDetail'], resolve)
        },

        {
          path: '/checkTipPage',
          component: (resolve) => require(['../views/class/checkTipPage'], resolve)
        },
        {
          path: '/zzrdPage',
          component: (resolve) => require(['../views/class/zzrdPage'], resolve)
        },
        {
          path: '/login',
          component: (resolve) => require(['../views/login/login'], resolve),
          meta: {
            title: "登录-浙江司法鉴定网",
          }
        },
        {
          path: '/videoPlayerPage',
          component: (resolve) => require(['../views/class/videoPlayerPage'], resolve),
        },
        {
          path:'/qtDetailPage',
          component:(resolve => require(['../views/class/qtDetailPage'],resolve)),
        },
        {
          path: '/userClassesPage',
          component: (resolve) => require(['../views/user/userClassesPage'], resolve)
        },
        {
          path: '/userClassDetailPage',
          component: (resolve) => require(['../views/user/userClassDetailPage'], resolve)
        },
        {
          path: '/studyPage',
          component: (resolve) => require(['../views/class/studyPage'], resolve),
          children: [
            {
              path: '/',
              component: (resolve) => require(['../views/class/allClassPage'], resolve),
            },
            {
              path: '/myClassPage',
              component: (resolve) => require(['../views/class/myClassPage'], resolve),
            },
            {
              path: '/applyClassPage',
              component: (resolve) => require(['../views/class/applyClassPage'], resolve),
            },
            {
              path: '/applyClassSqPage',
              component: (resolve) => require(['../views/class/applyClassSqPage'], resolve),
            },
            {
              path: '/applyeducationExemptionPage',
              component: (resolve) => require(['../views/class/applyeducationExemptionPage'], resolve),
            },
            {
              path: '/applyQtHoursPage',
              component: (resolve) => require(['../views/class/applyQtHoursPage'], resolve),
            },
            {
              path: '/myClassDetailPage',
              component: (resolve) => require(['../views/class/myClassDetailPage'], resolve),
            },
            {
              path: '/myOutLineClassPage',
              component: (resolve) => require(['../views/class/myOutLineClassPage'], resolve),
            },
            {
              path: '/myOutLineClassDetailPage',
              component: (resolve) => require(['../views/class/myOutLineClassDetailPage'], resolve),
            },
            {
              path: '/classDetailPage',
              component: (resolve) => require(['../views/class/classDetail'], resolve),
            },
            {
              path: '/courseUploadPage',
              component: (resolve) => require(['../views/class/courseUploadPage'], resolve),
            },
            {
              path: '/scoreManagerPage',
              component: (resolve) => require(['../views/class/scoreManagerPage'], resolve),
            },

            {
              path: '/zzApplyListPage',
              component: (resolve) => require(['../views/class/zzApplyListPage'], resolve),
            },
          ]
        },
        {
          path: '/myCenterPage',
          component: (resolve) => require(['../views/class/myCenterPage'], resolve),
          children: [
            {
              path: '/',
              component: (resolve) => require(['../views/class/institutionPage'], resolve),
            },
            {
              path: '/allYwbbPage1',
              component: (resolve) => require(['../views/form/allYwbbPage1'], resolve),
            },
            {
              path: '/jdytPage',
              component: (resolve) => require(['../views/form/jdytPage'], resolve),
            },
            {
              path: '/tsctPage',
              component: (resolve) => require(['../views/form/tsctPage'], resolve),
            },
            {
              path: '/wtztPage',
              component: (resolve) => require(['../views/form/wtztPage'], resolve),
            },
            {
              path: '/ywlbPage',
              component: (resolve) => require(['../views/form/ywlbPage'], resolve),
            },
            {
              path:'/wordPage',
              component:(resolve) => require(['../views/class/wordPage'],resolve),
            },
            {
              path:'/wordListPage',
              component:(resolve) => require(['../views/class/wordListPage'],resolve),
            },
            {
              path: '/institutionPage',
              component: (resolve) => require(['../views/class/institutionPage'], resolve),
            },
            {
              path: '/zzrdqkPage',
              component: (resolve) => require(['../views/class/zzrdqkPage'], resolve),
            },
            {
              path: '/orgPartyPage',
              component: (resolve) => require(['../views/center/orgPartyPage'], resolve),
            },
            {
              path: '/coursePartyPage',
              component: (resolve) => require(['../views/center/coursePartyPage'], resolve),
            },
            {
              path: '/sysrkqkPage',
              component: (resolve) => require(['../views/class/sysrkqkPage'], resolve),
            },
            {
              path: '/nlyzqkPage',
              component: (resolve) => require(['../views/class/nlyzqkPage'], resolve),
            },
            {
              path: '/personListPage',
              component: (resolve) => require(['../views/class/personListPage'], resolve),
            },
            {
              path: '/personAssistantPage',
              component: (resolve) => require(['../views/class/personAssistantPage'], resolve),
            },
            {
              path: '/agentListPage',
              component: (resolve) => require(['../views/class/agentListPage'], resolve),
            },
            {
              path: '/assistantPage',
              component: (resolve) => require(['../views/class/assistantPage'], resolve),
            },
            {
              path: '/assistantAddPage',
              component: (resolve) => require(['../views/class/assistantAddPage'], resolve),
            },

            {
              path: '/annualExaminePage',
              component: (resolve) => require(['../views/class/annualExaminePage'], resolve),
            },
          {
              path: '/informationEditListPage',
                component: (resolve) => require(['../views/class/informationEditListPage'], resolve),
            },
          {
            path: '/informationPersonEditListPage',
              component: (resolve) => require(['../views/class/informationPersonEditListPage'], resolve),
          },

              {
              path: '/annualExamineListPage',
              component: (resolve) => require(['../views/class/annualExamineListPage'], resolve),
            },

            {
              path: '/annualCheckPage',
              component: (resolve) => require(['../views/class/annualCheckPage'], resolve),
            },
            {
              path: '/annualCheckListPage',
              component: (resolve) => require(['../views/class/annualCheckListPage'], resolve),
            },
            {
              path: '/licensePage',
              component: (resolve) => require(['../views/class/licensePage'], resolve),
            },
            {
              path: '/orgInformationPage',
              component: (resolve) => require(['../views/class/orgInformationPage'], resolve),
            },
            {
              path: '/personInformationPage',
              component: (resolve) => require(['../views/class/personInformationPage'], resolve),
            },
            {
              path: '/pwdChangePage',
              component: (resolve) => require(['../views/class/pwdChangePage'], resolve),
            },
            {
              path: '/personPage',

              component: (resolve) => require(['../views/class/personPage'], resolve),
            },
            {
              path: '/historyScorePage',
              component: (resolve) => require(['../views/class/historyScorePage'], resolve),
            },
            {
              path: '/otherScorePage',
              component: (resolve) => require(['../views/class/otherScorePage'], resolve),
            },
            {
              path: '/educationExemptionPage',
              component: (resolve) => require(['../views/class/educationExemptionPage'], resolve),
            },

            {
              path: '/statisticalPage',
              component: (resolve) => require(['../views/class/statisticalPage'], resolve),
            },
            {
              path:'/administrativePage',
              component:(resolve)  => require(['../views/class/administrativePage'],resolve),
            }
          ]
        },
        {
          path: '/licenseRegistration',
          component: (resolve) => require(['../views/center/licenseRegistration'], resolve)
        }
      ]
    }
  ]
})
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};




// WEBPACK FOOTER //
// ./src/router/index.js